import * as API from '@/api';

export const actions = {
  // R: 取得藝品文章列表
  async getTemples({ commit }, data) {
    const params = {
      ...data,
      limit: 6
    }
    const list = await API.GET('/temples', params)

    // 濾掉下架的文章
    list.data.data = list.data.data.filter(temple => temple.is_on === 1);

    commit('setTemples', list.data);
  },

  // R: 取得一篇藝品文章
  async getTemple({ commit }, articleId) {
    const temple = await API.GET(`/temples/${articleId}`);

    if (!temple.data.tags) {
      temple.data.tags = [];
    }

    // 為導覽位置的手風琴加上設置
    if (temple.data.temple_guides) {
      temple.data.temple_guides.map((guide, index) => {
        guide.ariaExpanded = index === 0 ? true : false;
        return guide;
      });
    }


    commit('setTemple', temple.data);
  },
};